import React from 'react';
import PropTypes from 'prop-types';
import ReactResizeDetector from 'react-resize-detector';

import { MobileTabletOnly, DesktopUp } from 'shared/Responsive';
import Modal from './Modal';
import Video from './Video';

import OnboardingMp4 from 'videos/onboarding.mp4';
import OnboardingWebm from 'videos/onboarding.webm';

const types = {
  macroscopic: 'macroscopic',
  dermoscopic: 'dermoscopic'
};

const tips = {
  macroscopic: [
    'Take the photo about 4 inches away from the problem area',
    'Center your symptom in the photo',
    'Make sure there is good lighting',
    'Ensure your photo isn\'t blurry'
  ],
  dermoscopic: [
    'Attach a dermatoscope to your phone and use the non-polarized setting',
    'Use an alcohol swab to wipe the lesion, and place the dermatoscope on the lesion',
    'Adjust the distance between the dermatoscope and the skin until it\'s focused and take a photo',
    'If you have a polarizer on your dermatoscope, use it to take an additional photo of the lesion of interest'
  ]
};

const link = {
  macroscopic: 'View dermoscopy tips',
  dermoscopic: 'View macroscopy tips'
};

class Instructions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentIndex: 0,
      videoHeight: null,
      closeModal: false,
      type: types.macroscopic
    };
  }

  handleResize() {
    if (!this.photoInstructionEl) return;
    this.setState({ videoHeight: this.photoInstructionEl.clientHeight });
  }

  render() {
    const { type } = this.state;

    return (
      <Modal
        className={`photo-instructions ${this.props.className}`}
        closeModal={this.state.closeModal}
        onModalClose={this.onModalClosed.bind(this)}
        fullScreenOnMobile={false}
      >
        <div className={`photo-instructions__content ${type}`}>
          <div  ref={(el) => this.photoInstructionEl = el } className="photo-instructions__text">
            <ReactResizeDetector handleHeight onResize={this.handleResize.bind(this)} />
            <h2>Tips for taking the best photo</h2>

            <ul className="list--gradient">
              { tips[type].map((tip, idx) => (<li key={idx}>{ tip }</li>))}
            </ul>

            <button
              className="button button--gradient upload-button"
              onClick={this.closeModal.bind(this)}
            >
              Upload a photo
            </button>

            { this.props.showDermoscopicInstructions ?
              <div className="photo-instructions__type-switch" onClick={this.switchType.bind(this)}>
                { link[type] }
              </div>
              :
              <span className="button-spacer" />
            }
          </div>

          <MobileTabletOnly>
            { type === types.macroscopic ?
              <Video sources={{ mp4: OnboardingMp4, webm: OnboardingWebm }} />
              :
              <div className="image-container" />
            }
          </MobileTabletOnly>

          <DesktopUp>
            { type === types.macroscopic ?
              <Video height={this.state.videoHeight} sources={{ mp4: OnboardingMp4, webm: OnboardingWebm }} />
              :
              <div className="image-container" />
            }
          </DesktopUp>
        </div>
      </Modal>
    );
  }

  switchType() {
    this.setState({ type: (this.state.type === types.macroscopic) ? types.dermoscopic : types.macroscopic });
  }

  closeModal() {
    this.setState({ closeModal: true });
  }

  onModalClosed() {
    this.props.onInstructionsClosed();
  }
}

Instructions.defaultProps = {
  className: '',
  showDermoscopicInstructions: false
};

Instructions.propTypes = {
  className: PropTypes.string,
  showDermoscopicInstructions: PropTypes.bool,
  onInstructionsClosed: PropTypes.func.isRequired,
};

export default Instructions;
